import styled from "@emotion/styled";
import { rem } from "@triumph/design-system";

export const Container = styled.div`
    div > div {
        > div {
            border: ${rem(2)} solid
                ${({ theme }: any) => theme.colors.semantic.warningDefault};
        }
    }
`;